import { UPDATE_ESTIMATE_REQUIRED_TASK } from "../../Actions/ActionConstants";

function estimateTaskReducer(state=null,action){
    switch (action.type) {
        case UPDATE_ESTIMATE_REQUIRED_TASK:
                if(action.data){return action.data;}
                else{return state}
        default:
            return state;
    }
}
export default estimateTaskReducer